
export const basicFormData = () => ({
  inputData: {
    technician_id: "",
    quantity: "",
    is_active: true,
    material_id: "",
    available_quantity: "",
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");
  const payload = {
    modelName: "technician_inverts",
    schema: schema,
    include: [
      { model: "user_masters", as: "technician" },
      { model: "material_masters", as: "material" },
    ],
  };

  const navigatePage = { back: "/technician-inventory-list" };

  const headerName = "Technician Inventory";

  const validationType = "TechnicianInventoryCreate";
  const endpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    endpoint,
    getEndpoint,
  };
};

export const listPageData = () => {
  const schema = localStorage.getItem("schema");
  const payload = {
    modelName: "technician_inverts",
    schema: schema,
    include: [
      { model: "user_masters", as: "technician" },
      { model: "user_masters", as: "createdBy" },
      { model: "material_masters", as: "material" },
    ],
  };

  const navigatePage = {
    create: "/technician-inventory-create",
    edit: "/technician-inventory-create",
    view: "/technician-inventory-view",
  };

  const searchfields = [
    "technician.first_name",
    "technician.last_name",
    // "quantity",
  ];

  const headerName = "Technician Inventory";
  const endpoint = "/getRecords";
  const exportFileName = "TechnicianInventoryData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    endpoint,
    searchfields,
    exportFileName,
  };
};
